import { defineStore } from 'pinia';
import { api } from '../api/client';

interface User {
    id: string;
    email: string;
    role: 'admin' | 'user';
}

interface AuthState {
    user: User | null;
    token: string | null;
    loading: boolean;
    error: string | null;
}

export const useAuthStore = defineStore('auth', {
    state: (): AuthState => ({
        user: null,
        token: localStorage.getItem('promptpilot_token'),
        loading: false,
        error: null,
    }),

    getters: {
        isAuthenticated: (state) => !!state.token,
        isAdmin: (state) => state.user?.role === 'admin',
        currentUser: (state) => state.user,
    },

    actions: {
        async login(email: string, password: string) {
            this.loading = true;
            this.error = null;

            try {
                const response = await api.post('/auth/login', { email, password });
                const { token, user } = response.data;

                this.token = token;
                this.user = user;
                localStorage.setItem('promptpilot_token', token);

                return true;
            } catch (err: any) {
                this.error = err.response?.data?.message || 'Login failed';
                return false;
            } finally {
                this.loading = false;
            }
        },

        async fetchUser() {
            if (!this.token) return;

            try {
                const response = await api.get('/auth/me');
                this.user = response.data.user;
            } catch (err) {
                this.logout();
            }
        },

        logout() {
            this.user = null;
            this.token = null;
            this.error = null;
            localStorage.removeItem('promptpilot_token');
        },

        clearError() {
            this.error = null;
        },
    },
});
